import React, { useState, useRef } from 'react';

import { DISABLE_SWIPE } from '../utilities/enums';
import { useOverflowObserver } from '../helpers';

export const CrewMsg = ({ data }) => {
  const containerRef = useRef(null);
  const contentRef = useRef(null);
  const [isSwipeDisabled, setIsSwipeDisabled] = useState(false);

  useOverflowObserver(containerRef, contentRef, setIsSwipeDisabled);

  return (
    <div
      ref={containerRef}
      className={`crew-msg-container ${isSwipeDisabled ? DISABLE_SWIPE : ''}`}
    >
      <div ref={contentRef} style={{ width: 'fit-content' }}>
        <p className="crew-msg-title">CREW ALERT</p>
        <pre style={{ width: 'fit-content' }}>
          {data?.sCrewAlert?.[0] || 'No Crew Alert'}
        </pre>
        <br></br>
        <p className="crew-msg-title">CREW BULLETIN</p>
        <pre style={{ width: 'fit-content' }}>
          {data?.sCrewBulletin?.[0] || 'No Crew Bulletin'}
        </pre>
        <br></br>
        <p className="crew-msg-title">CREW ADDITIONAL INFO</p>
        <pre style={{ width: 'fit-content' }}>
          {data?.sCrewAdditionalInfo?.[0] || 'No Crew Additional Info'}
        </pre>
        <br></br>
        <p className="crew-msg-title">DISPATCH BRIEFING INFO</p>
        <pre style={{ width: 'fit-content' }}>
          {data?.sDispatchInfo?.[0] || 'No Dispatch Briefing Info'}
        </pre>
      </div>
    </div>
  );
};
